import { CustomConversion } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const cancelableFetchCustomConversions = async (adAccountId: string): Promise<CustomConversion[]> =>
    privateApiWithRouteLeavingCancelation.get<CustomConversion[]>(
        `facebook/graph/ad-accounts/${adAccountId}/custom-conversions`,
    );

export const CancelableCustomConversionGateway = {
    cancelableFetchCustomConversions,
};
